/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Select, Table, Tag, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import moment from 'moment/moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ROUTER } from '../../../constants/router';
import GlobalService from '../../../services/Global.service';
import WorkflowService from '../../../services/Workflow.service';
import IconEmpty from './iconEmply';
import usePermission from '../../../hooks/usePermission';

export const statusSwitch = (t, record) => {
    if (record?.status) {
        if (record.status.toLowerCase() === 'active') {
            return record.isUsed === true ? (
                <div className="text-center">
                    <Tag className="rounded-xl -my-1 text-center bg-[#4ACE8F] border-[#4ACE8F] text-white w-max m-auto">
                        {t('Active')}
                    </Tag>
                </div>
            ) : (
                <div className="text-center">
                    <Tag className="flex justify-center space-x-1 rounded-xl -my-1 text-center bg-[#F9C153] border-[#F9C153] text-white w-max m-auto">
                        <div>{t('Active')}</div>
                        <Tooltip
                            className="cursor-pointer"
                            placement="bottom"
                            overlayClassName="min-w-[20%]"
                            title={
                                <div className="whitespace-pre-line">
                                    {t('workFlow.ActiveTootip', {
                                        domainName: record?.domainName,
                                        dsTypeName: record?.dsTypeName,
                                    })}
                                </div>
                            }
                        >
                            <div className="text-xs">
                                <InfoCircleOutlined />
                            </div>
                        </Tooltip>
                    </Tag>
                </div>
            );
        } else {
            return (
                <div className="text-center">
                    <Tag className="flex justify-center space-x-1 rounded-xl -my-1 text-center bg-[#F0536F] border-[#F0536F] text-white w-max m-auto">
                        <div>{t('InActive')}</div>
                        <Tooltip
                            className="cursor-pointer"
                            placement="bottom"
                            overlayClassName="min-w-[20%]"
                            title={
                                <div className="whitespace-pre-line">
                                    {t('workFlow.InActiveTootip', {
                                        dsTypeName: record?.dsTypeName,
                                        domainName: record?.domainName,
                                    })}
                                </div>
                            }
                        >
                            <div className="text-xs">
                                <InfoCircleOutlined />
                            </div>
                        </Tooltip>
                    </Tag>
                </div>
            );
        }
    }
};

const WorkflowList = () => {
    const { t } = useTranslation();
    const { isAuditor, isUser } = usePermission();

    const [domainList, setDomainList] = useState([]);
    const [dsType, setDsType] = useState([]);
    const [workflowList, setWorkflowList] = useState([]);
    const [currentPage, setCurrentPage] = useState({
        page: 1,
        pageSize: 10,
        sortBy: 'name',
        sortDirection: 'ASC',
        total: 0,
    });
    const [allValues, setAllValues] = useState();
    const [loading, setLoading] = useState(false);

    const [form] = Form.useForm();

    const paginationProps = {
        current: parseInt(currentPage.page),
        // pageSize: 10,
        total: parseInt(currentPage.total),
        // showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total, range) => ` ${range[0]}-${range[1]} of ${total} `,
    };

    const onPageChange = async (pagination, filters, sorter) => {
        const pageValues = {
            page: pagination.current,
            pageSize: pagination.pageSize,
            sortBy: sorter && sorter.order ? sorter.columnKey : 'workflowName',
            sortDirection:
                sorter && sorter.order
                    ? sorter.order.substring(0, 3).toUpperCase() === 'ASC'
                        ? 'asc'
                        : 'desc'
                    : 'asc',
            //   total: pageValue.total,
            total: currentPage.total,
        };
        setCurrentPage(pageValues);
        getWorkflowList(allValues, pageValues);
    };

    const columns = [
        {
            title: t('Workflow Name'),
            dataIndex: 'workflowName',
            key: 'workflowName',
            sorter: true,
            render: (text, record) => (
                <div>
                    <div className="text-[#65707A] font-semibold text-sm">
                        {text}
                    </div>
                    <div>{record.workflowDescription}</div>
                </div>
            ),
        },
        {
            title: t('Domain'),
            dataIndex: 'domainName',
            key: 'domainName',
            className: 'text-[#65707A] font-semibold text-sm',
            sorter: true,
        },
        {
            title: t('Ds Type'),
            dataIndex: 'dsTypeName',
            key: 'dsTypeName',
            sorter: true,
            className: 'text-[#65707A] font-semibold text-sm',
            render: (text) => text ?? '-',
        },
        {
            title: t('Step'),
            dataIndex: 'step',
            key: 'step',
            className: 'text-[#65707A] font-semibold text-sm',
            sorter: true,
        },
        {
            title: t('Status'),
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            render: (status, record) => statusSwitch(t, record),
        },
        {
            title: t('Last Updated'),
            dataIndex: 'lastUpdate',
            key: 'lastUpdate',
            sorter: true,
            render: (text, record) => (
                <div className="text-[#65707A] font-semibold text-sm">
                    <div>{moment(text).format('DD/MM/YYYY')}</div>
                    <div>by {record.updateBy}</div>
                </div>
            ),
        },
        {
            title: t('Action'),
            align: 'center',
            render: (_, record) => {
                const linkTo = `${ROUTER.DS_360.WORKFLOW}/${record.workflowId}`;
                let actionIcon;
                if (isAuditor || isUser) {
                    actionIcon = EyeIcon;
                } else if (record?.status?.toLowerCase() === 'active') {
                    actionIcon = EditIcon;
                } else {
                    actionIcon = EyeIcon;
                }
                return <Link to={linkTo}>{actionIcon}</Link>;
            },
        },
    ];

    useEffect(() => {
        const getDomainList = async () => {
            try {
                const { data } = await GlobalService.getDomain();
                if (data?.resultData) {
                    const item = data?.resultData;
                    setDomainList(item?.filter((e) => e !== null) || []);
                }
            } catch (error) {
                console.log(error);
            }
        };
        const getDsTypeDropdown = async () => {
            try {
                const { data } = await GlobalService.getDsTypeDropdown();
                if (data?.resultData) {
                    const uniqueObjects = [
                        ...new Map(
                            data?.resultData.map((item) => [
                                item.dsTypeId,
                                item,
                            ])
                        ).values(),
                    ];
                    setDsType(uniqueObjects);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getDomainList();
        getDsTypeDropdown();
    }, []);

    const getWorkflowList = async (searchValue, pageValue) => {
        setLoading(true);
        const payload = {
            ...searchValue,
            p: pageValue.page || 1,
            ps: pageValue.pageSize || 10,
            s: pageValue.sortBy || 'workflowName',
            sd: pageValue.sortDirection || 'ASC',
        };
        try {
            const { data } = await WorkflowService.getWorkflowList(payload);
            if (data?.resultCode === 1) {
                setWorkflowList(data?.resultData?.result);
                setCurrentPage({
                    page: data?.resultData.page,
                    pageSize: data?.resultData.pageSize,
                    total: data?.resultData.total,
                });
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    const onValuesChange = (_, allValues) => {
        setAllValues(allValues);
        getWorkflowList(allValues, {
            page: 1,
            pageSize: 10,
        });
    };

    useEffect(() => {
        getWorkflowList(allValues, currentPage);
    }, []);

    return (
        <div>
            <div className="title ">{t('Workflow List')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Data Subject 360')} /{' '}
                </span>
                <span>{t('Workflow List')}</span>
            </div>
            <div className="mt-6 bg-white p-4 px-6 rounded-lg">
                <div className="text-xl font-medium">{t('Search Filter')}</div>
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    form={form}
                    onValuesChange={onValuesChange}
                    layout="inline"
                    className="mt-4"
                >
                    <Form.Item name="domainId">
                        <Select
                            placeholder={t('All Domain')}
                            style={{ width: 330 }}
                            size="large"
                            allowClear
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                (option?.children ?? '')
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            // onChange={onChangeDomain}
                        >
                            {domainList?.map((domain) => (
                                <Select.Option
                                    key={domain?.domainId}
                                    value={domain?.domainId}
                                >
                                    {domain?.domainName}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item name="dsTypeId">
                        <Select
                            placeholder={t('All Ds Type')}
                            style={{ width: 330 }}
                            size="large"
                            allowClear
                        >
                            {dsType?.map((dsType) => (
                                <Select.Option
                                    key={dsType?.dsTypeId}
                                    value={dsType?.dsTypeId}
                                >
                                    {dsType?.dsTypeName}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Form>
            </div>
            <div className="mt-4 bg-white p-4 px-6 rounded-lg">
                <div className="text-xl font-medium">{t('Workflow List')}</div>
                <div className="text-[13px] text-[#B5B5C3]">
                    {t(
                        'Menu for customizing the action steps for the data subject'
                    )}
                </div>
                <div className="text-xs text-[#65707A] my-4 font-semibold">
                    {t('TotalItems', { length: currentPage.total })}
                </div>
                <Table
                    loading={loading}
                    className="inbox_table"
                    rowKey={(record, i) => i}
                    dataSource={workflowList}
                    columns={columns}
                    locale={{
                        emptyText: (
                            <div className="my-16">
                                <IconEmpty />
                                <div className="text-sm text-[#65707A] pt-2 pb-4">
                                    {t(
                                        'Please create a DS Request Form before you can edit the workflow'
                                    )}
                                </div>
                                <div>
                                    <Link
                                        to={`${ROUTER.DS_360.DS_REQUEST_FORM}`}
                                    >
                                        <Button type="primary" size="large">
                                            {t(
                                                'Go to the DS Request Form page'
                                            )}
                                        </Button>
                                    </Link>
                                </div>
                            </div>
                        ),
                    }}
                    pagination={paginationProps}
                    onChange={onPageChange}
                />
            </div>
        </div>
    );
};

const EditIcon = (
    <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width={32} height={32} rx={6} fill="#F3F6F9" />
        <path
            d="M20.6587 9.3418L22.6587 11.3418L21.134 12.8671L19.134 10.8671L20.6587 9.3418ZM13.3334 18.6671H15.3334L20.1914 13.8091L18.1914 11.8091L13.3334 16.6671V18.6671Z"
            fill="#7B67FB"
        />
        <path
            d="M20.6667 20.6667H13.4387C13.4213 20.6667 13.4033 20.6733 13.386 20.6733C13.364 20.6733 13.342 20.6673 13.3193 20.6667H11.3333V11.3333H15.898L17.2313 10H11.3333C10.598 10 10 10.5973 10 11.3333V20.6667C10 21.4027 10.598 22 11.3333 22H20.6667C21.0203 22 21.3594 21.8595 21.6095 21.6095C21.8595 21.3594 22 21.0203 22 20.6667V14.888L20.6667 16.2213V20.6667Z"
            fill="#7B67FB"
        />
    </svg>
);

const EyeIcon = (
    <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width={32} height={32} rx={6} fill="#F3F6F9" />
        <path
            d="M16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z"
            fill="#7B67FB"
        />
        <path
            d="M23.4698 15.83C22.8817 14.3088 21.8608 12.9933 20.5332 12.046C19.2056 11.0988 17.6295 10.5613 15.9998 10.5C14.37 10.5613 12.794 11.0988 11.4664 12.046C10.1388 12.9933 9.11787 14.3088 8.52979 15.83C8.49007 15.9399 8.49007 16.0601 8.52979 16.17C9.11787 17.6912 10.1388 19.0067 11.4664 19.954C12.794 20.9012 14.37 21.4387 15.9998 21.5C17.6295 21.4387 19.2056 20.9012 20.5332 19.954C21.8608 19.0067 22.8817 17.6912 23.4698 16.17C23.5095 16.0601 23.5095 15.9399 23.4698 15.83ZM15.9998 19.25C15.357 19.25 14.7286 19.0594 14.1942 18.7023C13.6597 18.3452 13.2432 17.8376 12.9972 17.2437C12.7512 16.6499 12.6868 15.9964 12.8122 15.366C12.9376 14.7355 13.2472 14.1564 13.7017 13.7019C14.1562 13.2474 14.7353 12.9378 15.3657 12.8124C15.9962 12.687 16.6496 12.7514 17.2435 12.9974C17.8374 13.2434 18.3449 13.6599 18.7021 14.1944C19.0592 14.7289 19.2498 15.3572 19.2498 16C19.2485 16.8615 18.9056 17.6874 18.2964 18.2966C17.6872 18.9058 16.8613 19.2487 15.9998 19.25Z"
            fill="#7B67FB"
        />
    </svg>
);

export default WorkflowList;
